
import request from '@/utils/request'

// 春节答题填写信息
export function addChunJieUserInfo(data) {
    return request({
        method: 'POST',
        url: `/user/addChunJieUserInfo`,
        data
    })
}
// 获取用户信息
export function getChunJieUserInfo() {
    return request({
        method: 'POST',
        url: `/user/getChunJieUserInfo`,
    })
}
// 获取转盘数据
export function getTurntable() {
    return request({
        method: 'POST',
        url: `/prize/getTurntable`,
    })
}
// 我的奖品
export function getUserPrize(data) {
    return request({
        method: 'POST',
        url: `/prize/getUserPrize`,
        data
    })
}
// 抽奖
export function luckDraw(data) {
    return request({
        method: 'POST',
        url: `/prize/luckDraw`,
        data
    })
}
// 抽奖活动规则
export function getActionConfig() {
    return request({
        method: 'POST',
        url: `/actionConfig/getActionConfig`,
    })
}